export const NO_IMAGE =
    'https://sports-cdn.rmdevops.com/rightsholders-logos/no_image.jpg';
